/**
 * Manual port of the classe found here:
 * https://svn1.goodgamestudios.com/svn/games-goodgameTools/client/pathfinder/trunk/src/main/haxe/com/goodgamestudios/pathfinding/IndexedPriorityQueue.hx
 */
export class IndexedPriorityQueue {

    private _size: number = 0;
    private _indexValues: number[];
    private _compareValues: number[];

    constructor(compareValues: number[]) {
        this._indexValues = [];
        this._compareValues = compareValues;
        this._size = 0;
    }

    // insert newIndex at the end of the queue
    public sortInto(newIndex: number): void {
        this._size++;
        this._indexValues[this._size] = newIndex;
        this.sortUpTheHeap(this._size);
    }

    // remove and return the first element of the queue
    public pop(): number {
        let firstElement: number = this._indexValues[1];
        this._indexValues[1] = this._indexValues[this._size];
        this.sortDownTheHeap(1);
        this._size--;

        return firstElement;
    }

    // return number of elements in the queue
    public length(): number {
        return this._size;
    }

    private sortUpTheHeap(elementIndex: number): void {
        let elementIndexValue: number = this._indexValues[elementIndex];
        let elementCompareValue: number = this._compareValues[elementIndexValue];

        let parentIndex = elementIndex >> 1;

        while (parentIndex > 0) {
            let parentIndexValue: number = this._indexValues[parentIndex];

            if (elementCompareValue < this._compareValues[parentIndexValue]) {
                this._indexValues[elementIndex] = parentIndexValue;
                elementIndex = parentIndex;
                parentIndex >>= 1;
            } else {
                break;
            }
        }

        this._indexValues[elementIndex] = elementIndexValue;
    }

    private sortDownTheHeap(elementIndex: number): void {
        let elementIndexValue: number = this._indexValues[elementIndex];
        let elementCompareValue: number = this._compareValues[elementIndexValue];

        let childIndex: number = elementIndex << 1;
        let childIndexValue: number;

        while (childIndex < this._size) {
            if (childIndex < this._size - 1) {
                if (this._compareValues[this._indexValues[childIndex]] > this._compareValues[this._indexValues[childIndex + 1]]) {
                    childIndex++;
                }
            }

            childIndexValue = this._indexValues[childIndex];

            if (elementCompareValue > this._compareValues[childIndexValue]) {
                this._indexValues[elementIndex] = childIndexValue;
                elementIndex = childIndex;
                childIndex <<= 1;
            } else {
                break;
            }
        }

        this._indexValues[elementIndex] = elementIndexValue;
    }
}
